import { cloneDeep } from "lodash";
import React, { useState } from "react";
import { AiFillCalendar } from "react-icons/ai";
import AppButton from "../../common/AppButton";
import AppInput from "../../common/AppInput";
import Table from "../../common/Table";
import colors from "../../config/colors";
import moment from "moment";
const header = [
  { name: "startTime", title: "Start time" },
  { name: "endTime", title: "End time" },
  { name: "duration", title: "Duration" },
];
const formInit = {
  start: "",
  end: "",
  status: { name: "Done" },
};
export const LookupRange = () => {
  const Body = ({ events }) => {
    const [form, setForm] = useState(cloneDeep(formInit));
    const [data, setData] = useState();
    const handleSubmit = async (event) => {
      event.preventDefault();
      filterRange();
    };

    const filterRange = () => {
      const start = moment(form.start, "DD/MM/YYYY").toString();
      const end = moment(form.end, "DD/MM/YYYY").toString();
      const filtered = events.filter((i) => {
        return (
          new Date(start) < new Date(i.date) && new Date(end) > new Date(i.date)
        );
      });
      const done = filtered
        .filter((i) => i.status === form.status.name)
        .map((i) => {
          const startTime = moment(i.startTime, "hh:mma");
          const endTime = moment(i.endTime, "hh:mma");

          var duration = moment.duration(endTime.diff(startTime));
          const dur = `${duration.get("hours")}:${duration.get("minutes")}`;
          const durationx = `${duration.get("hours")}h ${duration.get(
            "minutes"
          )}m`;
          return { ...i, duration: durationx, dur };
        });

      setData(done);
    };
    const handleChange = ({ target }) => {
      const name = target.name;
      const value = target.value;
      setForm({ ...form, [name]: value });
    };

    const durSum = data
      ?.map((i) => i.dur)
      ?.reduce(
        (acc, time) => acc.add(moment.duration(time)),
        moment.duration()
      );
    const durHour = Math.floor(durSum?.asHours() || 0);
    const durMin = Math.floor(durSum?.minutes() || 0);
    return (
      <form
        id="form"
        onSubmit={handleSubmit}
        style={{ minHeight: 400, alignItems: "flex-start" }}
      >
        <div
          className="d-flex"
          style={{
            gap: 20,
            padding: "0px 30px",
          }}
        >
          <AppInput
            name="start"
            type="date"
            mask="99/99/9999"
            placeholder="DD/MM/YYYY"
            leftIcon={<AiFillCalendar color={colors.silver} size={23} />}
            label="Start date"
            floatLabel
            value={form.start}
            onChange={handleChange}
          />

          <AppInput
            name="end"
            label="End date"
            type="date"
            mask="99/99/9999"
            placeholder="DD/MM/YYYY"
            floatLabel
            value={form.end}
            onChange={handleChange}
            leftIcon={<AiFillCalendar color={colors.silver} size={23} />}
          />
          <AppInput
            name="status"
            label="Job Status"
            type="dropdown"
            noClear
            filterBy="name"
            floatLabel
            options={[
              { name: "Done" },
              { name: "Schedule" },
              { name: "Not Completed" },
            ]}
            value={form.status}
            onChange={handleChange}
            leftIcon={<AiFillCalendar color={colors.silver} size={23} />}
          />
        </div>

        <div>
          {data && (
            <div>
              <h5 className="text-center text-primary">
                {" "}
                {durHour}h {durMin}m{" "}
              </h5>
              <Table
                countNumber={false}
                header={header}
                data={data}
                normalTable
              />
            </div>
          )}
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </form>
    );
  };

  const Header = () => {
    return (
      <span className="d-flex" style={{ alignItems: "center" }}>
        <b>Lookup range</b>
      </span>
    );
  };

  const Footer = () => {
    return (
      <AppButton
        text="Lookup Range"
        form="form"
        type="submit"
        className="text-primary btn-light"
      />
    );
  };

  return { Header, Footer, Body };
};
